<app-layout>

  <app-hesap-kodu-sec-modal [source]="hesapPlani" [show]="showSelectHesapPlaniModalTs" [subeId]="fatura.subeId"
    (selectedHesapKodu)="selectHesapKodu($event)"></app-hesap-kodu-sec-modal>

  <div class="row" *ngIf="fatura">
    <div class="col-12" *ngIf="id!=='0'">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Fatura Onay Hareketleri</h4>
        </div>
        <div class="card-body p-0">
          <div class="row">
            <div class="col-12">
              <div class="table-responsive">
                <table class="table card-table table-vcenter text-nowrap datatable">
                  <thead>
                    <tr>
                      <th>Durum</th>
                      <th>Onay Durumu</th>
                      <th>Kullanıcı</th>
                      <th>Tarih</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody *ngIf="faturaHareketler">
                    <tr *ngFor="let k of faturaHareketler">
                      <td>{{k.faturaOnaySeviye?.kullaniciGrup?.isim}} onayında</td>
                      <td>{{k.isOnayText}}</td>
                      <td>{{k.kullanici?.adSoyad}}</td>
                      <td>{{k.olusturmaTarih | date: 'dd.MM.yyyy HH:mm:ss'}}</td>
                      <td class="text-right">
                        <div class="btn btn-sm btn-pill btn-success"
                          *ngIf="k.faturaOnaySeviye.id===fatura.faturaOnaySeviyeId && k.faturaOnaySeviye?.kullaniciGrupId===user.kullaniciGrupId && k.isOnay==null"
                          (click)="faturaOnayla(k.faturaOnaySeviye?.id,true)">Onayla
                        </div>
                        <div class="btn btn-sm btn-pill btn-danger ml-2"
                          *ngIf="k.faturaOnaySeviye.id===fatura.faturaOnaySeviyeId && k.faturaOnaySeviye?.kullaniciGrupId===user.kullaniciGrupId && k.isOnay==null"
                          (click)="faturaOnayla(k.faturaOnaySeviye.id,false)">Reddet
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title" [innerText]="id==='0'?'Yeni Fatura':'Fatura Düzenle'"></h4>
          <div class="card-options" *ngIf="!fatura.netsiseIslendi">
            <button class="btn btn-sm btn-pill btn-success" (click)="save()"
              [innerText]="id==='0'? 'Oluştur':'Değişiklikleri Kaydet'" *ngIf="id === '0' 
              || (
                    (
                    faturaHareketler && faturaHareketler.length > 0 
                    && faturaHareketler[faturaHareketler.length - 1].faturaOnaySeviye.kullaniciGrupId === user.kullaniciGrupId 
                    && faturaHareketler[faturaHareketler.length - 1].isOnay === null
                    )

                    || (faturaHareketler && faturaHareketler.length === 1 && faturaHareketler[faturaHareketler.length - 1].isOnay === null && fatura.kullaniciId === user.id)

                    || (faturaHareketler && faturaHareketler.length > 1 && faturaHareketler[faturaHareketler.length - 1].isOnay === null 
                        && faturaHareketler[faturaHareketler.length - 2].faturaOnaySeviye.kullaniciGrupId === user.kullaniciGrupId)
                 )
              || user.kullaniciGrupId === 11"></button>
            <!-- 1- onaylayacak kişi değişiklik yapabilir.-->
            <!-- 2- üst onaylayana kadar bir alttaki değişiklik yapabilir.-->
            <!-- 3- muhasebe grubu her onayda değişiklik yapabilir (kullaniciGrupId === 11).-->
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-lg-3">
              <div class="mb-3">
                <div class="form-label">Şube</div>
                <app-loading-input *ngIf="!subeler"></app-loading-input>
                <select *ngIf="subeler" class="form-control" [(ngModel)]="fatura.subeId"
                  [ngModelOptions]="{standalone: true}">
                  <option [value]="null" disabled selected>Şeçiniz</option>
                  <option *ngFor="let p of subeler" [ngValue]="p.id">{{p.isim}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-12 col-lg-3">
              <div class="mb-3">
                <div class="form-label">Fatura No</div>
                <input type="text" class="form-control" [(ngModel)]="fatura.faturaNo">
              </div>
            </div>
            <div class="col-md-12 col-lg-3">
              <div class="mb-3">
                <div class="mb-3">
                  <label class="form-label">Fatura Tipi</label>
                  <app-loading-input *ngIf="!faturaTipleri"></app-loading-input>
                  <select *ngIf="faturaTipleri" class="form-control" [(ngModel)]="fatura.faturaTipId"
                    [ngModelOptions]="{standalone: true}">
                    <option [value]="null" disabled selected>Seçiniz</option>
                    <option *ngFor="let p of faturaTipleri" [ngValue]="p.id">{{p.aciklama}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6 col-md-12">
              <div class="card p-0">
                <div class="card-header">
                  <h3 class="card-title">Cari: {{secilenCari?.firmaUnvani}}</h3>
                </div>
                <div class="card-body border-bottom py-3">
                  <div class="d-flex">
                    <div class="mr-auto text-muted">
                      Arama yap:
                      <div class="ml-2 d-inline-block">
                        <div class="input-icon mb-3">
                          <span class="input-icon-addon" style="left:auto;right:0;" *ngIf="cariAraLoading">
                            <div class="spinner-border spinner-border-sm text-muted" role="status"></div>
                          </span>
                          <input name="cariAra" [autocomplete]="true" type="text" class="form-control form-control-sm"
                            [(ngModel)]="cariAraText" placeholder="Yazın ve Enter'a basın"
                            (keyup.enter)="cariAraInputChange()">
                        </div>
                      </div>
                    </div>
                    <div class="text-muted">
                      Gösterilen
                      <div class="mx-2 d-inline-block">
                        <select class="form-control form-control-sm" [(ngModel)]="showSearchResultCountCari"
                          (change)="cariAraInputChange()">
                          <option *ngFor="let p of showSearchResultCountModelCari" [ngValue]="p">{{p}}</option>
                        </select>
                      </div>
                      sonuç sayısı
                    </div>
                  </div>
                </div>
                <div class="table-responsive" *ngIf="searchResultsCari && searchResultsCari.results">
                  <table class="table card-table table-vcenter text-nowrap datatable">
                    <thead>
                      <tr>
                        <th class="w-1">Cari Kodu</th>
                        <th>Firma Unvanı</th>
                        <th>Şehir</th>
                        <th>Telefon</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let c of searchResultsCari.results;let i=index" class="">
                        <td><span class="text-muted">{{c.cariKodu}}</span></td>
                        <td>{{c.firmaUnvani}}</td>
                        <td>{{c.sehir?.aciklama}}</td>
                        <td>{{c.telefon}}</td>
                        <td class="text-right">
                          <button class="btn btn-sm btn-success" (click)="addCari(c)"
                            [disabled]="talepId !== null ? false : !c.isFaturaKesilsin">Seç</button>
                          <div class="form-hint" *ngIf="talepId !== null ? false : !c.isFaturaKesilsin"><label
                              class="text-danger">Talepsiz Fatura Kesilemez!</label></div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="card-footer d-flex align-items-center" *ngIf="searchResultsCari">
                  <p class="m-0 text-muted"><span>{{searchResultsCari.rowCount}}
                      sonuçtan
                      {{searchResultsCari.firstRowOnPage}}</span>-<span>{{searchResultsCari.lastRowOnPage}}</span>
                    arası
                    sonuçlar
                  </p>
                  <ul class="pagination m-0 ml-auto">
                    <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPageCari === 1}">
                      <div class="page-link" tabindex="-1" (click)="showPreviousPageSearchResultsCari()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                          stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round"
                          stroke-linejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z"></path>
                          <polyline points="15 6 9 12 15 18"></polyline>
                        </svg>
                        önceki
                      </div>
                    </li>
                    <li class="page-item"
                      [ngClass]="{'disabled':showSearchCurrentPageCari === searchResultsCari.pageCount}">
                      <div class="page-link" (click)="showNextPageSearchResultsCari()">
                        sonraki
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                          stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round"
                          stroke-linejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z"></path>
                          <polyline points="9 6 15 12 9 18"></polyline>
                        </svg>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-lg-6 col-md-12">
              <div class="row">
                <div class="col-md-12 col-lg-6">
                  <div class="mb-3">
                    <div class="mb-3">
                      <label class="form-label">İlçe</label>
                      <input type="text" class="form-control" readonly [value]="secilenCari?.ilce">
                    </div>
                  </div>
                </div>
                <div class="col-md-12 col-lg-6">
                  <div class="mb-3">
                    <div class="mb-3">
                      <label class="form-label">İl</label>
                      <input type="text" class="form-control" readonly [value]="secilenCari?.sehir?.aciklama">
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6 col-md-12">
                  <div class="mb-3">
                    <div class="mb-3">
                      <label class="form-label">Vergi Dairesi</label>
                      <input type="text" class="form-control" readonly [value]="secilenCari?.vergiDairesi">
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-12">
                  <div class="mb-3">
                    <div class="mb-3">
                      <label class="form-label">Vergi Numarası</label>
                      <input type="text" class="form-control" readonly [value]="secilenCari?.vergiNo">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12 col-md-12">
              <div class="row">
                <div class="col-lg-2 col-md-12">
                  <div class="mb-3">
                    <div class="mb-3">
                      <label class="form-label">Fatura Tarihi</label>
                      <input mwlFlatpickr class="form-control mb-2 flatpickr-input" type="text"
                        placeholder="Fatura Tarihi" [altInput]="true" [convertModelValue]="true"
                        [(ngModel)]="fatura.tarih">
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-12">
                  <div class="mb-3">
                    <div class="mb-3">
                      <label class="form-label">Mal veya Hizmet Cinsi</label>
                      <input type="text" class="form-control" [(ngModel)]="fatura.malHizmetCinsi">
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-12">
                  <div class="mb-3">
                    <div class="mb-3">
                      <label class="form-label">Mal veya Hizmet Miktarı</label>
                      <input type="text" class="form-control" [(ngModel)]="fatura.malHizmetMiktar">
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-12">
                  <div class="mb-3">
                    <div class="mb-3">
                      <label class="form-label">Fatura Seri No</label>
                      <input type="text" class="form-control" [(ngModel)]="fatura.faturaSeriNo">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-12">
              <div class="mb-3">
                <label class="form-label">Açıklama</label>
                <textarea class="form-control" name="example-textarea-input" rows="6" placeholder="Açıklama.."
                  [(ngModel)]="fatura.aciklama"></textarea>
              </div>
            </div>
            <div class="col-lg-6 col-md-12">
              <app-aciklama-gecmisi [source]="aciklamaGecmisiTalep" [source2]="aciklamaGecmisiFatura">
              </app-aciklama-gecmisi>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6 col-md-12">
              <div class="mb-3">
                <div class="form-label">Görsel</div>
                <div class="form-file">
                  <input id="fileSelect" type="file" class="form-file-input" accept="image/*"
                    (change)="onFileChanged($event)">
                  <label class="form-file-label" for="fileSelect">
                    <span class="form-file-text">Dosya Seç...</span>
                    <span class="form-file-button">Göz At</span>
                  </label>
                </div>
              </div>
            </div>

            <div class="col-lg-6 col-md-12">
              <div class="mb-3">
                <div class="row row-sm">
                  <div class="col-6 col-sm-4 attachment" *ngFor="let g of fatura.faturaGorseller;let index = i">
                    <div class="container">
                      <img [src]="g.getUri()" alt="" class="image" style="width:100%">
                      <div class="middle">
                        <div class="card-body">
                          <div class="d-flex align-items-center">
                            <div class="ml-auto">
                              <a class="text clickable" (click)="removeGorsel(index)">
                                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-md" width="24" height="24"
                                  viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                                  stroke-linecap="round" stroke-linejoin="round">
                                  <path stroke="none" d="M0 0h24v24H0z"></path>
                                  <line x1="18" y1="6" x2="6" y2="18"></line>
                                  <line x1="6" y1="6" x2="18" y2="18"></line>
                                </svg>
                                Sil
                              </a>
                              <br>
                              <a class="ml-3 text clickable" (click)="downloadFile(g.dosya)">
                                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24"
                                  viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                                  stroke-linecap="round" stroke-linejoin="round">
                                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                  <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"></path>
                                  <polyline points="7 11 12 16 17 11"></polyline>
                                  <line x1="12" y1="4" x2="12" y2="16"></line>
                                </svg>
                                Görüntüle
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 col-sm-4 attachment" *ngFor="let t of talepGorseller;let index = i">
                    <div class="container">
                      <img src="assets/img/logo.png" alt="" class="image" style="width:100%">
                      <div class="middle">
                        <div class="card-body">
                          <div class="d-flex align-items-center">
                            <div class="ml-auto">
                              <a class="text clickable" (click)="removeGorsel(index)">
                                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-md" width="24" height="24"
                                  viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                                  stroke-linecap="round" stroke-linejoin="round">
                                  <path stroke="none" d="M0 0h24v24H0z"></path>
                                  <line x1="18" y1="6" x2="6" y2="18"></line>
                                  <line x1="6" y1="6" x2="18" y2="18"></line>
                                </svg>
                                Sil
                              </a>
                              <br>
                              <a class="ml-3 text clickable" (click)="downloadFile(t.dosya)">
                                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24"
                                  viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                                  stroke-linecap="round" stroke-linejoin="round">
                                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                  <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"></path>
                                  <polyline points="7 11 12 16 17 11"></polyline>
                                  <line x1="12" y1="4" x2="12" y2="16"></line>
                                </svg>
                                Görüntüle
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="col-12">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Fatura Kalemleri</h3>
        </div>
        <div class="table-responsive">
          <table *ngIf="fatura?.faturaKalemler?.length>0" class="table card-table table-vcenter text-nowrap datatable">
            <thead>
              <tr>
                <th class="w-1">Stok Kodu</th>
                <th>Stok Adı</th>
                <th>Ek Alan</th>
                <th>Miktar</th>
                <th>Birim</th>
                <th>Birim Fiyat</th>
                <th>Doviz Tipi</th>
                <th>Kdv</th>
                <th>Muhasebe Kodu</th>
                <th>Sarf Yeri</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let k of fatura.faturaKalemler;let i=index;" [id]="'cart'+i">
                <td><span class="text-muted">{{k.stokKodu}}</span></td>
                <td><span class="text-muted">{{ k.stokAdi }}</span></td>
                <td><input type="text" class="form-control" [readOnly]="!k.stokKodu.search('HIZMET')" [(ngModel)]="k.ekAlan"></td>
                <td><input type="number" class="form-control" (change)="toplamHesapla()" [(ngModel)]="k.miktar"></td>
                <td><span class="text-muted">{{k.olcuBirimi}}</span></td>
                <td><input type="number" class="form-control" (change)="toplamHesapla()" [(ngModel)]="k.birimFiyat">
                </td>
                <td><select *ngIf="paraBirimList" class="form-control" (change)="toplamHesapla()"
                    [(ngModel)]="k.paraBirimiId" [ngModelOptions]="{standalone: true}">
                    <!-- <option [value]="1" selected>Şeçiniz</option> -->
                    <option *ngFor="let p of paraBirimList" [ngValue]="p.id">{{p.aciklama}}</option>
                  </select>
                <td>{{ k.kdvOrani }}</td>
                <td>{{ k.muhasebeKodu }} <button *ngIf="!k.stokKodu.search('HIZMET')" class="btn btn-warning btn-sm"
                    (click)="showSelectHesapKodu(k)">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                      stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <circle cx="15" cy="15" r="4" />
                      <path d="M18.5 18.5l2.5 2.5" />
                      <path d="M4 6h16" />
                      <path d="M4 12h4" />
                      <path d="M4 18h4" />
                    </svg>
                  </button></td>
                <td><select *ngIf="sarfYeriList" class="form-control" [(ngModel)]="k.sarfYeriId"
                    [ngModelOptions]="{standalone: true}">
                    <option [value]="null" disabled selected>Seçiniz</option>
                    <option *ngFor="let p of sarfYeriList" [ngValue]="p.id">{{p.aciklama}}</option>
                  </select></td>
                <td class="text-right">
                  <div class="btn btn-sm btn-danger" (click)="removeFromRequestList(i)">Kaldır</div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-center p-3" *ngIf="fatura?.faturaKalemler?.length===0">
            Kalem eklenmedi!
          </div>
        </div>

        <div class="card-footer text-center">
          <b class="display-6 text-blue">Brüt Toplam: </b> <span class="display-6 text-blue">{{brutToplamText}}</span>
          <br><b class="display-6">KDV 1:</b> <span class="display-6 text-blue">{{kdv1Toplam}}</span>
          <br><b class="display-6">KDV 8:</b> <span class="display-6 text-blue">{{kdv8Toplam}}</span>
          <br><b class="display-6">KDV 18:</b> <span class="display-6 text-blue">{{kdv18Toplam}}</span>
          <br><strong class="display-6 text-red"><b>Genel Toplam: </b></strong> <span
            class="display-6 text-red">{{genelToplamText}}</span>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Yeni Fatura Kalemi</h3>
        </div>
        <div class="card-body border-bottom py-3">
          <div class="d-flex">
            <div class="mr-auto text-muted">
              Arama yap:
              <div class="ml-2 d-inline-block">
                <div class="input-icon mb-3">
                  <span class="input-icon-addon" style="left:auto;right:0;" *ngIf="kalemAraLoading">
                    <div class="spinner-border spinner-border-sm text-muted" role="status"></div>
                  </span>
                  <input name="kalemAra" [autocomplete]="true" type="text" class="form-control form-control-sm"
                    [(ngModel)]="kalemAraText" placeholder="Yazın ve Enter'a basın"
                    (keyup.enter)="kalemAraInputChange()">
                </div>
              </div>
            </div>
            <div class="text-muted">
              Gösterilen
              <div class="mx-2 d-inline-block">
                <select class="form-control form-control-sm" [(ngModel)]="showSearchResultCount"
                  (change)="kalemAraInputChange()">
                  <option *ngFor="let p of showSearchResultCountModel" [ngValue]="p">{{p}}</option>
                </select>
              </div>
              sonuç sayısı
            </div>
          </div>
        </div>
        <div class="table-responsive" *ngIf="searchResults && searchResults.results">
          <table class="table card-table table-vcenter text-nowrap datatable">
            <thead>
              <tr>
                <th class="w-1">Stok Kodu</th>
                <th>Stok Adı</th>
                <th>Ek Alan</th>
                <th>Miktar</th>
                <th>Birim</th>
                <th>Birim Fiyat</th>
                <th>Doviz Tipi</th>
                <th>Kdv</th>
                <th>Muhasebe Kodu</th>
                <th>Sarf Yeri</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let k of searchResults.results;let i=index" [id]="'row'+i">
                <td><span class="text-muted">{{k.stokKodu}}</span></td>
                <!-- <td><span class="text-muted">{{ k.stokAdi }}</span></td> -->
                <td><input type="text" class="form-control" [(ngModel)]="k.stokAdi"
                    [readOnly]="k.stokKodu.search('HIZMET')"></td>
                <td><input type="text" class="form-control" [readOnly]="!k.stokKodu.search('HIZMET')" [(ngModel)]="k.ekAlan"></td>
                <td><input type="number" class="form-control" [(ngModel)]="k.talepEdilen"></td>
                <td><span class="text-muted">{{k.olcuBirimi}}</span></td>
                <td><input type="number" class="form-control" [(ngModel)]="k.birimFiyat"></td>
                <td><select *ngIf="paraBirimList" class="form-control" [(ngModel)]="k.paraBirimiId">
                    <!-- <option [value]="1" selected>Şeçiniz</option> -->
                    <option *ngFor="let p of paraBirimList" [ngValue]="p.id">{{p.aciklama}}</option>
                  </select>
                <td>{{ k.kdvOrani }}</td>
                <td>{{ k.muhasebeKodu }} <button *ngIf="!k.stokKodu.search('HIZMET')" class="btn btn-warning btn-sm"
                    (click)="showSelectHesapKodu(k)">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                      stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <circle cx="15" cy="15" r="4" />
                      <path d="M18.5 18.5l2.5 2.5" />
                      <path d="M4 6h16" />
                      <path d="M4 12h4" />
                      <path d="M4 18h4" />
                    </svg>
                  </button></td>
                <td><select *ngIf="sarfYeriList" class="form-control" [(ngModel)]="k.sarfYeriId"
                    [ngModelOptions]="{standalone: true}">
                    <option [value]="null" disabled selected>Şeçiniz</option>
                    <option *ngFor="let p of sarfYeriList" [ngValue]="p.id">{{p.aciklama}}</option>
                  </select></td>
                <td class="text-right">
                  <div class="btn btn-sm btn-success" (click)="addToRequestList(k,'row'+i)">Ekle</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="card-footer d-flex align-items-center" *ngIf="searchResults">
          <p class="m-0 text-muted"><span>{{searchResults.rowCount}}
              sonuçtan {{searchResults.firstRowOnPage}}</span>-<span>{{searchResults.lastRowOnPage}}</span> arası
            sonuçlar
          </p>
          <ul class="pagination m-0 ml-auto">
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPage === 1}">
              <div class="page-link" tabindex="-1" (click)="showPreviousPageSearchResults()">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="15 6 9 12 15 18"></polyline>
                </svg>
                önceki
              </div>
            </li>
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPage === searchResults.pageCount}">
              <div class="page-link" (click)="showNextPageSearchResults()">
                sonraki
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="9 6 15 12 9 18"></polyline>
                </svg>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</app-layout>